import { render, staticRenderFns } from "./FilterByDepartmentTag.vue?vue&type=template&id=7b96db97&scoped=true"
import script from "./FilterByDepartmentTag.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterByDepartmentTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilterByDepartmentTag.vue?vue&type=style&index=0&id=7b96db97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b96db97",
  null
  
)

export default component.exports